import './index.css'
import React from 'react';
import SimpleEditor from '../common/SimpleEditor';


export default function Description({ action, siteForm, handleChange }: any) {
  return (
    <React.Fragment>
      <div className='site-form-section'>
        <div className='site-form-section-title'>
          <p>DESCRIPCIÓN</p>
        </div>

        <div className='site-form-section-item__desc'>
          <SimpleEditor
            name='description'
            value={siteForm.description}
            label='Descripción'
            disabled={action === 'view'}
            handleChange={handleChange}
          />
        </div>

      </div>
    </React.Fragment>
  );
}
